var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Popconfirm } from 'antd';
import { Select } from 'ui/styled';
import { BLUE } from 'ui/constants';
import { dataLoader } from 'utils/helpers';
import useSurveySelect from './useSurveySelect';
var SurveySelect = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = useState(value), selectedSurvey = _b[0], setSelectedSurvey = _b[1];
    var _c = useState(), pendingSurvey = _c[0], setPendingSurvey = _c[1];
    var _d = useState(false), popupOpen = _d[0], setPopupOpen = _d[1];
    useEffect(function () {
        setSelectedSurvey(value);
    }, [value]);
    var _e = useSurveySelect(), data = _e.data, functions = _e.functions;
    var loading = data.loading, options = data.options;
    var debouncedSearch = functions.debouncedSearch, onPopupScroll = functions.onPopupScroll;
    var handleConfirm = function (survey) { return __awaiter(void 0, void 0, void 0, function () {
        var selected, isErrorFree;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selected = survey || pendingSurvey;
                    if (!selected) return [3 /*break*/, 2];
                    return [4 /*yield*/, onChange(selected)];
                case 1:
                    isErrorFree = (_a.sent()).isErrorFree;
                    setPopupOpen(false);
                    setPendingSurvey(undefined);
                    if (isErrorFree) {
                        setSelectedSurvey(selected);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectChange = function (survey) {
        setPendingSurvey(survey);
        return selectedSurvey ? setPopupOpen(true) : handleConfirm(survey);
    };
    var handleCancel = function () {
        setPopupOpen(false);
        setPendingSurvey(undefined);
    };
    return (_jsx(Popconfirm, { title: "Changing the survey will delete any previous responses.", open: popupOpen, onConfirm: function () { return handleConfirm(); }, onCancel: handleCancel, disabled: !!selectedSurvey, okButtonProps: {
            'data-test': 'surveyPopConfirmOkBtn',
            style: {
                background: BLUE,
                border: BLUE,
                borderRadius: 6
            }
        }, cancelButtonProps: {
            'data-test': 'surveyPopConfirmCancelBtn',
            style: {
                borderRadius: 6
            }
        }, children: _jsx(Select, { placeholder: "Select survey", showSearch: { filterOption: false, onSearch: debouncedSearch }, value: pendingSurvey || selectedSurvey, onPopupScroll: onPopupScroll, onChange: handleSelectChange, notFoundContent: dataLoader(loading), loading: loading, options: options, "data-test": "surveySelect" }) }));
};
export default SurveySelect;
